import { createContext, useState } from "react";

const CloudContext = createContext();

function CloudProvider({ children }) {
  const [region, setRegion] = useState(null);
  const [idpool, setIdpool] = useState(null);
  const [cloudinary_cloud, setCloudinary_cloud] = useState(null);
  const [cloudinary_preset, setCloudinary_preset] = useState(null);
  const [cesium_token, setCesium_token] = useState(null);

  const cloudValue = {
    region,
    setRegion,
    idpool,
    setIdpool,
    cloudinary_cloud,
    setCloudinary_cloud,
    cloudinary_preset,
    setCloudinary_preset,
    cesium_token,
    setCesium_token
  };

  return (
    <CloudContext.Provider value={cloudValue}>{children}</CloudContext.Provider>
  );
}

export { CloudProvider, CloudContext };